import initSearch from "@rei/search-input-suggestions";
import './style/entry.scss';
import './js/entry';
import './js/shared/services/UserService';

initSearch();
